<script lang="ts">
    import WidthBox from "../../components/WidthBox.svelte";
    import DetailHeader from "../../components/DetailHeader.svelte";
    import DetailHeaderSubnavigation from "../../components/DetailHeaderSubnavigation.svelte";
    import { t } from "@lernetz/svelte-translate";
    import Icon from "@lernetz/svelte-icon/Icon.svelte";
    //import { MaterialSearchResponse } from "../../gateway/FlinkGateway";
    import MaterialDummy from "../../components/MaterialDummy.svelte";
    import Material from "../../components/Material.svelte";
    import { get } from "svelte/store";
    import { sharedProps, setupSharedProps, flinkGateway, requests } from "../../services";
    import Image from "@lernetz/svelte-image/components/Image.svelte";

    export let course;

    setupSharedProps();


    let subNavigationItems = [{route: '', title: 'learn-packages'}];
    let collectionMaterialPromise;


    function getCollectionMaterials() {
        collectionMaterialPromise = flinkGateway.searchCollectionMaterials(course.collection.publicId, {
          limit: 100,
          offset: 0,
          query: "",
          sort: "created_at:desc",
          filters: {},
          progress: true
        } );
    }

    getCollectionMaterials();


</script>


<DetailHeader padding={false} backlinkText={"module-overview"} baseSegment={"courses"} subNavigationItems={subNavigationItems} />

<WidthBox paddingBottom={false} paddingHorizontal={false}>
    <div class="mt-80 flex flex-col sm:flex-row sm:h-screen">
        <div class="sm:basis-1/3 sm:mx-0 border-r bg-light-grey border-medium-grey ">
            <div class="sm:sticky top-112">
                <div class="flex justify-center p-32 ">
                    <Image
                        class="w-full absolute inset-0 object-cover z-0 w-144 h-144"
                        request={requests.assets}
                        vars={{ file_name: course.icon?.file_name, preset: "medium.png" }}
                    />
                </div>
                <h2 class="px-16 pb-48 pt-24 mt-56 md:text-24 lg:text-28 font-bold text-ellipsis overflow-hidden text-center">{course.title}</h2>
            </div>
        </div>
        <div class="sm:basis-2/3">
            <div class="sm:hidden flex justify-center h-80 border-b border-t sm:border-t-0 border-medium-grey sticky top-80 bg-white z-50">
                <DetailHeaderSubnavigation subNavigationItems={subNavigationItems}></DetailHeaderSubnavigation>
            </div>
            <div class="mt-32 mx-16 sm:mx-32 lg:mx-48 pb-16 sm:pb-32 lg:pb-48 grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-24 gap-y-32 content-center">
                {#await collectionMaterialPromise}
                        <MaterialDummy />
                        <MaterialDummy />
                    {:then materialSearchResponse}
                        {#each materialSearchResponse.results.sort( (a,b) => get(get(a).material).title > get(get(b).material).title ?  1 : -1  ) as collectionMaterial}
                            <Material model={get(collectionMaterial).material} collection={course.collection} />
                        {/each}
                    {:catch}
                        <div>{$t("no-learning-packages-found")}</div>
                    {/await}
            </div>
        </div>
    </div>
</WidthBox>

